import { create } from "zustand";

/**
 * Single, minimal Zustand store for the daily draw (hard rule: one store per app).
 * Almost everything is SERVER state — this store mirrors /api/draw/state plus the
 * client↔server clock offset so every screen counts down to the same instant.
 */

export interface DrawLast {
  roundId: number;
  outcome: number;
  winners: number;
  total: number;
  me: { picked: number; hit: boolean } | null;
}

export interface DrawState {
  serverNow: number;
  roundId: number;
  endsAt: number;
  locked: boolean;
  slots: number;
  count: number;
  distribution: number[];
  myPick: number | null;
  myStreak: number;
  last: DrawLast | null;
}

interface DrawStore {
  state: DrawState | null;
  /** serverNow − Date.now() at fetch time; corrected clock = Date.now() + offset. */
  clockOffset: number;
  /** Reveal theater: not-started | spinning | shown (for the round in `state.last`). */
  reveal: "idle" | "spinning" | "shown";

  apply: (s: DrawState) => void;
  setReveal: (r: DrawStore["reveal"]) => void;
}

export const useDrawStore = create<DrawStore>((set) => ({
  state: null,
  clockOffset: 0,
  reveal: "idle",

  apply: (s) => set({ state: s, clockOffset: s.serverNow - Date.now() }),
  setReveal: (reveal) => set({ reveal }),
}));
